import React from "react"
import numeral from "numeral"

class EstimatedTimeDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row && this.props.row.type && this.props.row.type.estimated_time) {
      return (
        <div>{numeral(this.props.row.type.estimated_time).format('0' + this.props.delimiter + '0') + " " + I18n.t("minutes")}</div>
      )
    } else if(this.props.data){
      return (
        <div>{numeral(this.props.data).format('0' + this.props.delimiter + '0') + " " + I18n.t("minutes")}</div>
      )
    } else {
      return (
        <span className="none">{I18n.t('none')}</span>
      )
    }
  }

};

export default EstimatedTimeDataType